import { Box, Grow, styled, Typography, Zoom } from "@mui/material";
import React, { useState } from "react";
import radius from "../images/radius.png";

const HoverLayerStyle = styled(Box)`
  position: relative;

  .radius {
    position: absolute;
    top: -14px;
    left: 0;
    width: 100%;
  }

  & > *:not(.radius) {
    position: relative;
    z-index: 20;
  }
`;

const HoverBoxStyle = styled(Box)`
  position: absolute !important;
  top: calc(100% + 24px);
  left: calc(50% - 160px);
  z-index: 15;
  background: white !important;
  padding: 1rem;
  border-left: 6px solid #4d97f9;
  background: linear-gradient(
    90deg,
    #ffffff 56.51%,
    rgba(255, 255, 255, 0) 106.75%
  );
  border-radius: 0;
  overflow: visible;
  width: 320px;
  height: max-content;

  &:before {
    content: "";
    width: 6px;
    height: 32px;
    position: absolute;
    top: 0;
    left: -6px;
    background: #40d6fb;
  }
`;

const HoverBox = ({ anchorEl, title, onClose, style }) => {
  return (
    <Grow
      in={Boolean(anchorEl)}
      {...(Boolean(anchorEl) ? { timeout: 600 } : {})}
    >
      <HoverBoxStyle style={style}>
        <Typography variant="body2" color="textPrimary">
          {title}
        </Typography>
      </HoverBoxStyle>
    </Grow>
  );
};

const HoverLayer = ({ title, children, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { left, right } = props;
  let customStyle = {};
  if (left) customStyle = { left: "calc(137% - 160px)" };
  if (right) customStyle = { left: "calc(-28% - 160px)" };

  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <HoverLayerStyle
      {...props}
      onMouseEnter={(e) => {
        setAnchorEl(e.currentTarget);
      }}
      onMouseLeave={onClose}
    >
      <Zoom in={Boolean(anchorEl)}>
        <img src={radius} alt="" className="radius" />
      </Zoom>

      <HoverBox style={customStyle} anchorEl={anchorEl} title={title} />
      {children}
    </HoverLayerStyle>
  );
};

export { HoverBox, HoverLayer };
